(() => {
  if (!customElements.get('hb-buy-buttons')) {
    customElements.define('hb-buy-buttons', class extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.addToCartLabel && !this.dataset.buyNowLabel) return;
        const syncLabels = () => {
          const addButton = this.querySelector('.product-form__submit');
          const addLabel = addButton?.querySelector('span');
          if (this.dataset.addToCartLabel && addLabel && !addButton.disabled && addButton.getAttribute('aria-disabled') !== 'true') {
            if (addLabel.textContent !== this.dataset.addToCartLabel) addLabel.textContent = this.dataset.addToCartLabel;
          }
          if (this.dataset.buyNowLabel) {
            this.querySelectorAll('button.shopify-payment-button__button--unbranded').forEach((button) => {
              if (button.textContent !== this.dataset.buyNowLabel) button.textContent = this.dataset.buyNowLabel;
              if (button.getAttribute('aria-label') !== this.dataset.buyNowLabel) button.setAttribute('aria-label', this.dataset.buyNowLabel);
            });
          }
        };
        this.labelObserver?.disconnect();
        syncLabels();
        this.labelObserver = new MutationObserver(syncLabels);
        this.labelObserver.observe(this, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      }
      disconnectedCallback() {
        this.labelObserver?.disconnect();
      }
    });
  }

  if (!window.hoobroFeatureNavigationReady) {
    window.hoobroFeatureNavigationReady = true;
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-hb-features-link]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      const details = target.matches('details') ? target : target.querySelector('details');
      if (details) {
        details.open = true;
        details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
      }
      for (let parent = target.parentElement; parent; parent = parent.parentElement) {
        if (parent.matches('details')) parent.open = true;
      }
      const stickyHeader = document.querySelector('.section-header');
      const offset = stickyHeader ? stickyHeader.getBoundingClientRect().height + 20 : 24;
      target.style.scrollMarginTop = `${offset}px`;
      const focusTarget = details?.querySelector('summary') || target;
      if (!focusTarget.matches('summary,a,button,[tabindex]')) focusTarget.tabIndex = -1;
      focusTarget.focus({ preventScroll: true });
      target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      history.replaceState(history.state, '', link.hash);
    });
  }
  if (!customElements.get('hb-delivery-estimate')) {
    customElements.define('hb-delivery-estimate', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.mode !== 'dates') return;
        const minimum = Math.max(0, Number(this.dataset.min) || 0);
        const maximum = Math.max(minimum, Number(this.dataset.max) || minimum);
        const businessDays = this.dataset.business === 'true';
        const today = new Date();
        const deliveryDate = (days) => {
          const date = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 12);
          for (let count = 0; count < days;) {
            date.setDate(date.getDate() + 1);
            if (!businessDays || (date.getDay() !== 0 && date.getDay() !== 6)) count += 1;
          }
          return date;
        };
        let formatter;
        try { formatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { month: 'short', day: 'numeric' }); }
        catch { formatter = new Intl.DateTimeFormat('en', { month: 'short', day: 'numeric' }); }
        const message = (this.dataset.message || '')
          .replaceAll('[start_date]', formatter.format(deliveryDate(minimum)))
          .replaceAll('[end_date]', formatter.format(deliveryDate(maximum)));
        const output = this.querySelector('[data-delivery-message]');
        if (output && message) output.textContent = message;
      }
    });
  }
})();
